/* eslint-disable react/no-danger */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import useScrollToTop from '../../hooks/useScrollToTop';
import * as AppPropTypes from '../../lib/PropTypes';

import Menu from '../menus/Menu';
import Page from './Page';

import styles from '../../../styles/pages/page.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const PageSectionPage = ({ page, className }) => {
    useScrollToTop(page);

    return (
        <Page
            page={page}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {page.isIndex && typeof page.children !== 'undefined' && page.children.length > 0 ? (
                <Menu
                    className={styles.children}
                    items={page.children.map(({ title, url, items }) => ({
                        label: title,
                        url,
                        items,
                    }))}
                />
            ) : null}
        </Page>
    );
};

PageSectionPage.propTypes = propTypes;
PageSectionPage.defaultProps = defaultProps;

export default PageSectionPage;
